import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 导入语言文件
import en from './en'
import zh from './zh'
import ru from './ru'
import ar from './ar'
import es from './es'
import ko from './ko'
import ja from './ja'
import tr from './tr'

// 从 localStorage 获取语言设置
const savedLanguage = localStorage.getItem('language')

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: savedLanguage || 'en', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages: {
    en,
    zh,
    ru,
    ar,
    es,
    ko,
    ja,
    tr
  }
})

export default i18n